import React, { useEffect, useRef } from 'react';
import './BenefitsSection.css';

const benefits = [
  { id: 1, icon: '/icons/benefit1.webp', title: 'Improved efficiency' },
  { id: 2, icon: '/icons/benefit2.webp', title: 'Enhanced customer experience' },
  { id: 3, icon: '/icons/benefit3.webp', title: 'Increased agility and innovation' },
  { id: 4, icon: '/icons/benefit4.webp', title: 'Data-driven decision-making' },
  { id: 5, icon: '/icons/benefit5.png', title: 'Expanded marketreach' },
];

const BenefitsSection = () => {
  const headingRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (headingRef.current) observer.observe(headingRef.current);
    cardRefs.current.forEach(ref => ref && observer.observe(ref));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="benefits-section" id = "benefits">
      <div className="container">
      <div className="benefits-header">
        <h2 className="fade-in-left" ref={headingRef}>
          WHAT <span className="blue">YOU’LL GET</span>
        </h2>
      </div>

      <div className="benefits-cards">
        <div className="card-row">
          <div className="benefit-card fade-up" ref={el => cardRefs.current[0] = el}>
            <img src={benefits[0].icon} alt="" className="benefit-icon" />
            <h3>{benefits[0].title}</h3>
          </div>

          <div className="benefit-card fade-up" ref={el => cardRefs.current[3] = el}>
            <img src={benefits[3].icon} alt="" className="benefit-icon" />
            <h3>{benefits[3].title}</h3>
          </div>

          <div className="benefit-card fade-up" ref={el => cardRefs.current[1] = el}>
            <img src={benefits[1].icon} alt="" className="benefit-icon" />
            <h3>{benefits[1].title}</h3>
          </div>
        </div>

        <div className="card-row">
          <div className="benefit-card fade-up" ref={el => cardRefs.current[4] = el}>
            <img src={benefits[4].icon} alt="" className="benefit-icon" />
            <h3>{benefits[4].title}</h3>
          </div>

          <div className="benefit-card fade-up" ref={el => cardRefs.current[2] = el}>
            <img src={benefits[2].icon} alt="" className="benefit-icon" />
            <h3>{benefits[2].title}</h3>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
